import { ParserAbstraction } from "./parser.abstraction";
import { ParserFunctionType } from "../parser.type";
import { CategoryStoreModel } from "../../../../models/store/category.store.model";
import { CategoryResponse } from "../../../../models/data/response/category.response";
import { Category } from "../../../../models/data/blobby/category.data";
import { category_v0_to_v1 } from "../model-dto/category";
import { EstimateActionStoreModel } from "../../../../models/store/estimate.action.store.model";
import { EstimateActionResponse } from "../../../../models/data/response/estimate-action.response";
import { Estimate } from "../../../../models/data/blobby/estimate.data";
import { EstimateActionData } from "../../../../models/data/blobby/estimate.action.data";
import { estimateAction_v0_to_v1 } from "../model-dto/estimate.action";

export class EstimateActionParser extends ParserAbstraction {
  override getParser(version: number): ParserFunctionType {
    if (!this.isSupportedVersion(version)) {
      throw new Error(`Unsupported Estimate Action parser version ${version}`);
    }

    if (version === 0) {
      return EstimateActionParser_v0;
    } else {
      return EstimateActionParser_v1;
    }
  }

  override getSupportedVersion(): number[] {
    return [0, 1];
  }
}

const EstimateActionParser_v1 = (estimateActionItem: any): any =>
  estimateActionItem as EstimateActionStoreModel;
const EstimateActionParser_v0 = (estimateActionItem: any): any => {
  const response = new EstimateActionResponse(estimateActionItem);
  const estimateAction = new EstimateActionData(response);
  const upgraded = estimateAction_v0_to_v1(estimateAction);
  /** We need to remap the vid properties as this is new and was not map in the previous blobby type **/
  upgraded.vid = estimateActionItem.vid ?? "";
  return EstimateActionParser_v1(upgraded);
};
